import PropTypes from 'prop-types'
import React from 'react'

export const DeleteBtn = ({item, index, onClick}) =>
  <div>
    <span
      className='remove-btn'
      data-tmpid={item.tmpId}
      data-id={item.id}
      data-index={index}
      onClick={onClick}
    >
      &#10006;
    </span>
  </div>

DeleteBtn.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    tmpId: PropTypes.string,
    id: PropTypes.number
  }).isRequired,
  onClick: PropTypes.func.isRequired
}

DeleteBtn.defaultProps = {
  index: 0
}
